import { Nav, Wrapper, Logo, Menu, NavLink } from './styles';
import scrollProps from '../../sections/Navigation/scrollProps';
import ThemeButton from '../ThemeButton';

const NavBar = ({ isScrollDown }) => {
  return (
    <Nav isScrollDown={isScrollDown}>
      <Wrapper>
        <Logo href="/">
          <span>{'{'}</span>
          <span>A</span>
          <span>{'}'}</span>
        </Logo>
        <Menu>
          <NavLink to="home" {...scrollProps}>
            Home
          </NavLink>
          <NavLink to="skills" {...scrollProps}>
            Skills
          </NavLink>
          <NavLink to="projects" {...scrollProps}>
            Projects
          </NavLink>
          <NavLink to="contact" {...scrollProps}>
            Contact
          </NavLink>
          <ThemeButton />
        </Menu>
      </Wrapper>
    </Nav>
  );
};

export default NavBar;
